import React, {useRef, useState, useEffect} from 'react';
import styles from './Finalist.module.scss';
import {useSelector} from "react-redux";
import {finalists} from "components/homePanels/e_contest/Finalists.data";
import FinalistCarousel from "components/homePanels/e_contest/finalistCarousel/FinalistCarousel";
import {buttonClick} from "utils/Helpers";
import panelStyles from "components/homePanels/Panels.module.scss";
import DetailsModal from "components/homePanels/e_contest/detailsModal/DetailsModal";

const Finalist = (props) => {

    const accessible = useSelector(state => state.accessible);
    const windowData = useSelector(state => state.window);
    const pos = useRef({ top: 0, left: 0, x: 0, y: 0 });
    const container = useRef();
    const pointerDownTarget = useRef(false);
    const [activeFinalist, setActiveFinalist] = useState(null);
    const [activeLightbox, toggleActiveLightbox] = useState(false);

    const setContainerRef = (el) => {
        if(!el) return;
        container.current = el;
        container.current.scrollLeft = window.innerWidth * .10;
        container.current.scrollTop = window.innerHeight * .10;
    }

    const mouseDownHandler = function(e) {

        pointerDownTarget.current = true;

        pos.current = {
            // The current scroll
            left: container.current.scrollLeft,
            top: container.current.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };

        container.current.style.cursor = 'grabbing';
        container.current.style.userSelect = 'none';

    };

    const mouseMoveHandler = function(e) {

         if(pointerDownTarget.current) {

            // How far the mouse has been moved
            const dx = e.clientX - pos.current.x;
            const dy = e.clientY - pos.current.y;

            // Scroll the element
            container.current.scrollTop = pos.current.top - dy;
            container.current.scrollLeft = pos.current.left - dx;

         }

    };

    const mouseUpHandler = function() {
        pointerDownTarget.current = false;
        container.current.style.cursor = 'grab';
        container.current.style.removeProperty('user-select');
    };

    function setAttributes(index){

        let attrs = {
            style: {backgroundImage: `url(${finalists[index].carousel.slice(-1)})`}
        }

        if(!activeLightbox){

            let clickAttrs = {
                tabIndex : 0,
                role: 'button',
                "aria-label": `See submissions from ${finalists[index].name}`,
                onClick: index !== activeFinalist ? ()=>setActiveFinalist(index) : ()=>toggleActiveLightbox(true),
                onKeyDown: (e)=>buttonClick(e),
            }

            if(windowData.width > 768){
                attrs = {
                    ...attrs,
                    children: <div className={styles.hover}><span {...clickAttrs}>Meet {finalists[index].name}</span></div>
                }
            } else {
                attrs = {
                    ...attrs,
                    ...clickAttrs
                }
            }
        }

        return attrs
    }

    useEffect(()=>{
        toggleActiveLightbox(activeFinalist !== null)
    }, [activeFinalist])

    function buildLayout(){
        if(windowData.width > 768){
            return (
                <div className={`${styles.grid} ${styles.desktop}`}>
                    <div className={styles.col}>
                        <div className={styles.row} {...setAttributes(0)}/>
                        <div className={`${styles.row} ${styles.rowColumns}`}>
                            <div className={styles.colRow} {...setAttributes(1)}/>
                            <div className={styles.colRow} {...setAttributes(2)}/>
                        </div>
                        <div className={styles.row} {...setAttributes(3)}/>
                        <div className={`${styles.row} ${styles.rowColumns}`}>
                            <div className={styles.colRow} {...setAttributes(4)}/>
                            <div className={styles.colRow} {...setAttributes(5)}/>
                        </div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.row} {...setAttributes(6)}/>
                        <div className={`${styles.row} ${styles.rowDouble}`} {...setAttributes(7)}/>
                        <div className={styles.row} {...setAttributes(8)}/>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.row} {...setAttributes(9)}/>
                        <div className={styles.row} {...setAttributes(10)}/>
                        <div className={styles.row} {...setAttributes(11)}/>
                        <div className={styles.row} {...setAttributes(12)}/>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.row} {...setAttributes(13)}/>
                        <div className={`${styles.row} ${styles.rowColumns}`}>
                            <div className={styles.colRow} {...setAttributes(14)}/>
                            <div className={styles.colRow} {...setAttributes(15)}/>
                        </div>
                        <div className={`${styles.row} ${styles.rowDouble}`} {...setAttributes(16)}/>
                    </div>
                    <div className={styles.col}>
                        <div className={`${styles.row} ${styles.rowDouble}`} {...setAttributes(17)}/>
                        <div className={styles.row} {...setAttributes(18)}/>
                        <div className={styles.row} {...setAttributes(19)}/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={`${styles.grid} ${styles.mobile}`}>
                    <div className={`${styles.grid} ${styles.desktop}`}>
                        <div className={styles.col}>
                            <div className={styles.row} {...setAttributes(0)}/>
                            <div className={styles.row} {...setAttributes(1)}/>
                            <div className={styles.row} {...setAttributes(2)}/>
                            <div className={`${styles.row} ${styles.rowColumns}`}>
                                <div className={styles.colRow} {...setAttributes(3)}/>
                                <div className={styles.colRow} {...setAttributes(4)}/>
                            </div>
                            <div className={styles.row} {...setAttributes(5)}/>
                            <div className={styles.row} {...setAttributes(6)}/>
                            <div className={styles.row} {...setAttributes(7)}/>
                        </div>
                        <div className={styles.col}>
                            <div className={styles.row} {...setAttributes(8)}/>
                            <div className={`${styles.row} ${styles.rowDouble}`} {...setAttributes(9)}/>
                            <div className={styles.row} {...setAttributes(10)}/>
                            <div className={styles.row} {...setAttributes(11)}/>
                            <div className={`${styles.row} ${styles.rowColumns}`}>
                                <div className={styles.colRow} {...setAttributes(12)}/>
                                <div className={styles.colRow} {...setAttributes(13)}/>
                            </div>
                            <div className={styles.row} {...setAttributes(14)}/>
                        </div>
                        <div className={styles.col}>
                            <div className={`${styles.row} ${styles.rowDouble}`} {...setAttributes(15)}/>
                            <div className={styles.row} {...setAttributes(16)}/>
                            <div className={styles.row} {...setAttributes(17)}/>
                            <div className={`${styles.row} ${styles.rowDouble}`} {...setAttributes(18)}/>
                            <div className={styles.row} {...setAttributes(19)}/>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            <div className={styles.gridWrapper} ref={(el)=>setContainerRef(el)} onMouseDown={mouseDownHandler} onMouseMove={mouseMoveHandler} onMouseUp={mouseUpHandler}>


                {buildLayout()}

                {activeFinalist === null && <DetailsModal finalistModal={true}/>}

                <span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Click to view all entries'} onKeyDown={buttonClick}
                      className={`explore ${panelStyles.explore} ${panelStyles.button} ${panelStyles.white} ${styles.button}`} onClick={props.showGallery}>
                                    <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:'Click to view all entries'}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>
                                </span>
            </div>

            {activeLightbox && <FinalistCarousel activeFinalist={activeFinalist} setActiveFinalist={setActiveFinalist} close={()=>toggleActiveLightbox(false)}/>}
        </>
    )
};

export default Finalist
